<template>
  <div class="wrap">
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group" v-if="isEventSelectorVisible || hasSelectedEvents">
              <label>Selected event(s)</label>
              <select class="form-control" v-model="selectedEvent" v-on:change="addSelectedEvent" v-if="isEventSelectorVisible">
                <option v-for="event in events" :value="event">{{ event.text }} {{ formatDate(event.start_date) }} ({{ event.resource_name }})</option>
              </select>
              <ul class="list-group">
                <li class="list-group-item selected-event" v-for="se in selectedEvents"><button class="btn btn-default event-remove" v-on:click="removeSelectedEvent(se)">&times;</button><span class="item-text"><span class="item-name">{{ se.text }}</span><span class="item-times"><span class="item-date">{{ formatDate(se.start_date) }}</span><span class="item-resource">{{ se.resource_name }}</span></span></span></li>
              </ul>        
            </div>
            <div class="form-group" v-if="isResourceSelectorVisible || hasSelectedResources">
              <label>Selected resource(s)</label>
              <select class="form-control" v-model="selectedResource" v-on:change="addSelectedResource" v-if="isResourceSelectorVisible">
                <option v-for="resource in resources" :value="resource">{{ resource.name }}</option>
              </select>
              <ul class="list-group">
                <li class="list-group-item selected-event" v-for="sr in selectedResources"><button class="btn btn-default event-remove" v-on:click="removeSelectedResource(sr)">&times;</button><span class="item-text"><span class="item-name">{{ sr.name }}</span></span></li>
              </ul>        
            </div>
            <div class="form-group" v-if="isTimeSelectorVisible">
              <label>Selected start time(s)</label>
              <select class="form-control" v-model="selectedTime" v-on:change="addSelectedTime">
                <option v-for="time in times" :value="time">{{ makeTime(time) }}</option>
              </select>
              <ul class="list-group">
                <li class="list-group-item selected-time" v-for="st in selectedTimes"><button class="btn btn-default event-remove" v-on:click="removeSelectedTime(st)">&times;</button><span class="item-text"><span class="item-name">{{ makeTime(st) }} ({{ makeDate(st) }})</span></span></li>
              </ul>        
            </div>
            <div class="form-group">
              <label>Use external scanner</label>
              <select class="form-control" v-model="externalScanner">
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
            <!-- <div class="form-group">
              <label>Environment</label>
              <select class="form-control" v-model="environment">
                <option value="production">Production</option>
                <option value="kube">Kubernetes</option>
              </select>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="container transparent footer-container">
      <button class="btn btn-success footer-button-halfwidth left-button settings-submit" :disabled="!canStartScanning" v-on:click="scan">Start scanning</button>
      <button class="btn btn-danger scan-logout footer-button-halfwidth right-button" v-on:click="logout">Logout</button>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import moment from 'moment'
import localConfig from '../../config/local.json'
import { authFetch } from '../lib/api'

export default {
  name: 'Settings',
  data () {
    return {
      events: [],
      resources: [],
      resourcepools: [],
      times: []
    }
  },
  computed: {
    ...mapGetters([
      'baseDomain',
      'apiKey',
      'defaultShopId'
    ]),
    isEventSelectorVisible () {
      if (!this.events || !this.events.length) {
        return false
      }
      if (this.selectedResources && this.selectedResources.length) {
        return false
      }
      return true
    },
    hasSelectedEvents () {
      if(this.selectedEvents && this.selectedEvents.length) {
        return true
      }
      return false
    },
    isResourceSelectorVisible () {
      if (!this.resources || !this.resources.length) {
        return false
      }
      if (this.selectedEvents && this.selectedEvents.length) {
        return false
      }
      return true
    },
    hasSelectedResources () {
      if(this.selectedResources && this.selectedResources.length) {
        return true
      }
      return false
    },
    isTimeSelectorVisible () {
      return this.times && this.times.length && this.isResourceSelectorVisible
    },
    canStartScanning () {
      if(this.selectedEvents && this.selectedEvents.length) {
        return true
      }
      if(this.selectedResources && this.selectedResources.length && this.selectedTimes && this.selectedTimes.length) {
        return true
      }
      return false
    },
    selectedEvent: {
      get () {
        return this.$store.state.selectedEvent
      },
      set (newValue) {
        this.$store.dispatch('setSelectedEvent', newValue)
      }
    },
    selectedEvents: {
      get () {
        return this.$store.state.selectedEvents
      },
      set (newValue) {
        this.$store.dispatch('setSelectedEvents', newValue)
      }
    },
    selectedResource: {
      get () {
        return this.$store.state.selectedResource
      },
      set (newValue) {
        this.$store.dispatch('setSelectedResource', newValue)
      }
    },
    selectedResources: {
      get () {
        return this.$store.state.selectedResources
      },
      set (newValue) {
        this.$store.dispatch('setSelectedResources', newValue)
      }
    },
    selectedTime: {
      get () {
        return this.$store.state.selectedTime
      },
      set (newValue) {
        this.$store.dispatch('setSelectedTime', newValue)
      }
    },
    selectedTimes: {
      get () {
        return this.$store.state.selectedTimes
      },
      set (newValue) {
        this.$store.dispatch('setSelectedTimes', newValue)
      }
    },
    externalScanner: {
      get () {
        return this.$store.state.externalScanner ? 1 : 0
      },
      set (newValue) {
        this.$store.dispatch('setExternalScanner', parseInt(newValue) === 1 ? true : false)
      }
    },
    environment: {
      get () {
        return this.$store.state.baseDomain === 'kube.johku.com' ? 'kube' : 'production'
      },
      set (newValue) {
        switch (newValue) {
          case 'kube':
            this.$store.dispatch('setBaseDomain', 'kube.johku.com')
            this.$store.dispatch('setBridgeUri', 'wss://kube.johku.com/ws/')
            break
          default:
            this.$store.dispatch('setBaseDomain', localConfig.baseDomain)
            this.$store.dispatch('setBridgeUri', localConfig.bridgeUri)
            break
        }
      }
    },
    shopId () {
      return this.defaultShopId
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('D.M.YYYY H.mm')
    },
    makeTime (ts) {
      return moment.unix(ts).format('H.mm')
    },
    makeDate (ts) {
      return moment.unix(ts).format('D.M.YYYY')
    },
    scan () {
      this.$router.push('/scan')
    },
    addSelectedEvent () {
      for (var i = 0; i < this.selectedEvents.length; i++) {
        if (this.selectedEvents[i].id == this.selectedEvent.id) {
          this.selectedEvent = null
          return
        }
      }
      this.selectedEvents.push(this.selectedEvent)
      this.selectedEvent = null
    },
    removeSelectedEvent (event) {
      for (var i = 0; i < this.selectedEvents.length; i++) {
        if (this.selectedEvents[i].id == event.id) {
          this.selectedEvents.splice(i, 1)
        }
      }
      this.selectedEvent = null
    },
    addSelectedResource () {
      for (var i = 0; i < this.selectedResources.length; i++) {
        if (this.selectedResources[i].id == this.selectedResource.id) {
          this.selectedResource = null
          return
        }
      }
      this.selectedResources.push(this.selectedResource)
      this.selectedResource = null
      this.reloadTimes()
    },
    removeSelectedResource (resource) {
      for (var i = 0; i < this.selectedResources.length; i++) {
        if (this.selectedResources[i].id == resource.id) {
          this.selectedResources.splice(i, 1)
        }
      }
      this.selectedResource = null
      this.reloadTimes()
    },
    addSelectedTime () {
      for (var i = 0; i < this.selectedTimes.length; i++) {
        if (this.selectedTimes[i] == this.selectedTime) {
          this.selectedTime = null
          return
        }
      }
      this.selectedTimes.push(this.selectedTime)
      this.selectedTime = null
    },
    removeSelectedTime (time) {
      for (var i = 0; i < this.selectedTimes.length; i++) {
        if (this.selectedTimes[i] == time) {
          this.selectedTimes.splice(i, 1)
        }
      }
      this.selectedTime = null
    },
    reloadTimes () {
      let $this = this
      let resourceIds = []
      for (var i = 0; i < this.selectedResources.length; i++) {
        resourceIds.push(this.selectedResources[i].id)
      }
      if (!resourceIds.length) {
        this.times = []
        this.selectedTime = null
        this.selectedTimes = []
        return
      }
      let resourceIdStr = resourceIds.join(',')
      let d = new Date()
      d.setHours(0, 0, 0, 0)
      let ts = d.getTime() / 1000
      authFetch(this.baseDomain, this.shopId, 'tickets.json?starttimes=true&ts=' + ts + '&resources=' + resourceIdStr, this.apiKey)
      .then((response) => {
        response.json().then(data => {
          if (data) {
            $this.times = data
          }
        })
      })
    },
    logout: function () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  },
  mounted () {
    let $this = this
    let d = new Date()
    let yy= d.getFullYear()
    let mm = d.getMonth() + 1
    let dd = d.getDate()
    if (mm < 10) {
      mm = '0' + mm
    }
    if (dd < 10) {
      dd = '0' + dd
    }
    let dateStr = yy + '-' + mm + '-' + dd
    authFetch(this.baseDomain, this.shopId, 'showschedule.json?from=' + dateStr, this.apiKey)
    .then((response) => {
      response.json().then(data => {
        if (data && data.data) {
          $this.events = data.data
        }
      })
    })
    authFetch(this.baseDomain, this.shopId, 'resources.json?withtickets=true', this.apiKey)
    .then((response) => {
      response.json().then(data => {
        if (data) {
          $this.resources = data
        }
      })
    })
    authFetch(this.baseDomain, this.shopId, 'resourcepools.json?withtickets=true', this.apiKey)
    .then((response) => {
      response.json().then(data => {
        if (data) {
          $this.resourcepools = data
        }
      })
    })
    if (this.selectedResources && this.selectedResources.length) {
      this.reloadTimes()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings.vue